import { useCallback } from 'react'

export type LogCategory = 'phase' | 'api' | 'livekit' | 'mic' | 'session' | 'error' | 'info'
export type LogFn = (category: LogCategory, message: string, data?: unknown) => void

export function useConversationLogger(): LogFn {
  return useCallback<LogFn>((category, message, data) => {
    const prefix = `[VC:${category.toUpperCase()}]`
    if (category === 'error') {
      console.error(prefix, message, data ?? '')
    } else {
      console.info(prefix, message, data ?? '')
    }
  }, [])
}
